import { listParts, uploadPart, deletePart, type PartInfo } from "./parts-api";

const dropZone = document.getElementById("drop-zone") as HTMLLabelElement;
const fileInput = document.getElementById("upload-input") as HTMLInputElement;
const partsList = document.getElementById("parts-list") as HTMLUListElement;
const errorEl = document.getElementById("upload-error") as HTMLDivElement;

function renderParts(parts: PartInfo[]): void {
  if (parts.length === 0) {
    partsList.classList.add("empty");
    partsList.textContent = "No parts uploaded yet.";
    return;
  }
  partsList.classList.remove("empty");
  partsList.innerHTML = "";
  for (const p of parts) {
    const li = document.createElement("li");
    const name = document.createElement("span");
    name.className = "name";
    name.textContent = p.name;
    const meta = document.createElement("span");
    meta.className = "meta";
    meta.textContent = formatBytes(p.size);
    const del = document.createElement("button");
    del.textContent = "Delete";
    del.addEventListener("click", async () => {
      if (!confirm(`Delete ${p.name}?`)) return;
      del.disabled = true;
      try {
        await deletePart(p.name);
        await refresh();
      } catch (err) {
        showError((err as Error).message);
        del.disabled = false;
      }
    });
    li.append(name, meta, del);
    partsList.appendChild(li);
  }
}

function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
}

function showError(msg: string): void {
  errorEl.textContent = msg;
  errorEl.hidden = false;
}

function clearError(): void {
  errorEl.hidden = true;
}

async function refresh(): Promise<void> {
  try {
    renderParts(await listParts());
  } catch (err) {
    showError((err as Error).message);
  }
}

async function handleFiles(files: FileList | File[]): Promise<void> {
  clearError();
  const list = Array.from(files);
  if (list.length === 0) return;
  for (const file of list) {
    try {
      await uploadPart(file);
    } catch (err) {
      showError(`${file.name}: ${(err as Error).message}`);
    }
  }
  await refresh();
}

fileInput.addEventListener("change", () => {
  if (fileInput.files) void handleFiles(fileInput.files);
  fileInput.value = "";
});

["dragenter", "dragover"].forEach((ev) => {
  dropZone.addEventListener(ev, (e) => {
    e.preventDefault();
    dropZone.classList.add("over");
  });
});
["dragleave", "drop"].forEach((ev) => {
  dropZone.addEventListener(ev, (e) => {
    e.preventDefault();
    dropZone.classList.remove("over");
  });
});
dropZone.addEventListener("drop", (e) => {
  if (e.dataTransfer?.files) void handleFiles(e.dataTransfer.files);
});

void refresh();
